(() => {
  const init = () => {
    const dialog = document.getElementById('lrl-gift-dialog');
    const trigger = document.querySelector('[data-lrl-gift]');
    if (!dialog || !trigger || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const close = () => { if (dialog.open) dialog.close(); };
    trigger.addEventListener('click', () => {
      if (dialog.open) return close();
      dialog.showModal();
      document.documentElement.classList.add('lrl-gift-open');
      trigger.setAttribute('aria-expanded', 'true');
    });
    dialog.querySelector('.bf-close').addEventListener('click', close);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('lrl-gift-open');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus({preventScroll:true});
    });
    window.addEventListener('pagehide', close);
    window.addEventListener('popstate', close);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
